// extracted by mini-css-extract-plugin
export default {"market":"styles_market__zPlaH","cups":"styles_cups__robcO","body":"styles_body__wjvkl","lines":"styles_lines__IwGP8","bets":"styles_bets__D2Giu"};